export default __webpack_public_path__ + "static/media/greyLogo.109cefad.svg";